/* src/app/addons/approval/approval-list.component.css */
/*# sourceMappingURL=approval-list.component-UDOHTGJT.css.map */
